// actionTypes.js
import { NAME } from './constants';

export const SET_PATIENTS_LOADING = `${NAME}/SET_PATIENTS_LOADING`;

export const SET_LOOKUP_DATA = `${NAME}/SET_LOOKUP_DATA`;

export const SET_PATIENT_INFO = `${NAME}/SET_PATIENT_INFO`;

export const SET_PATIENT_DATA_LOADING = `${NAME}/SET_PATIENT_DATA_LOADING`;